import React, { Component } from 'react';

import UsersApi from 'apis/Users';
import {
  getConfirmationGracePeriod,
  getConfirmed,
  getUserData,
} from 'constants/localStorageManager';
import 'assets/scss/header.css';

import Toaster from '../Toaster';
import EmailConfirmationSent from '../ConfirmationModal/Modal/EmailConfirmationSent';

class EmailConfirmationBanner extends Component {
  constructor() {
    super();
    this.state = {
      isConfirmationSentVisible: false,
      email: '',
    };
  }

  toggleConfirmationSent = () => {
    this.setState(({ isConfirmationSentVisible }) => ({
      isConfirmationSentVisible: !isConfirmationSentVisible,
    }));
  };

  resendEmail = () => {
    const { email } = getUserData();
    UsersApi.resendConfirmation(email)
      .then(({ data }) => {
        const { email } = data;

        this.setState({ isConfirmationSentVisible: true, email });
        Toaster.getSuccessToaster(
          'check-circle',
          'Confirmation email sent successfully'
        );
      })
      .catch(error => {
        Toaster.getFailureToaster(
          error,
          'exclamation-triangle',
          'Error while sending confirmation email'
        );
      });
  };

  render() {
    const { isConfirmationSentVisible, email } = this.state;

    if (getConfirmed()) {
      return null;
    }

    const xDaysLeftText =
      getConfirmationGracePeriod() <= 7
        ? `${getConfirmationGracePeriod()} days left`
        : '';

    return (
      <React.Fragment>
        <EmailConfirmationSent
          isVisible={isConfirmationSentVisible}
          email={email}
          toggleModal={this.toggleConfirmationSent}
        />
        <div className="top-message-banner">
          <div className="container">
            <div className="row">
              <div className="col-md-12 mx-auto">
                <p className="pt-3 d-inline mr-5">
                  {`To continue to enjoy all the benefits of Soono, please verify
                your email address. ${xDaysLeftText}`}
                </p>
                <button className="btn ml-4 mx-auto" onClick={this.resendEmail}>
                  Resend Email
                </button>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default EmailConfirmationBanner;



// WEBPACK FOOTER //
// ./src/components/Banners/EmailConfirmationBanner.js